import { render, staticRenderFns } from "./QuizDetails.vue?vue&type=template&id=4bf76176&scoped=true&"
import script from "./QuizDetails.vue?vue&type=script&lang=ts&"
export * from "./QuizDetails.vue?vue&type=script&lang=ts&"
import style0 from "./QuizDetails.vue?vue&type=style&index=0&id=4bf76176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf76176",
  null
  
)

export default component.exports